import styled from '@emotion/styled';
import { TRACKER_MESSAGE_TRANSPORT } from '@racemap/sdk/schema/trackers';
import { Form, Switch } from 'antd';
import { DateTime } from 'luxon';
import { type FC, useEffect } from 'react';
import { DatePicker } from '../../BasicComponents/DateTimePicker';
import { VStack } from '../../BasicComponents/MetaComponent';
import type { FormValues } from './AddTrackerCommando';

export const PlannedAtDatePicker: FC = () => {
  const form = Form.useFormInstance<FormValues>();
  const transport = Form.useWatch('transport');
  const forceNow = Form.useWatch('forceNow');
  const minDate = DateTime.now();

  useEffect(() => {
    if (!forceNow) {
      form.resetFields(['plannedAt']);
    }
  }, [forceNow]);

  return (
    <Container>
      <VStack>
        <Form.Item
          labelCol={{ flex: '150px' }}
          dependencies={['forceNow']}
          wrapperCol={{ flex: 1 }}
          label="Not before"
          className="form-input-planned-at"
          name="plannedAt"
          tooltip="Set a date and time and the message will be sent only after this time."
        >
          <DatePicker
            minDate={minDate}
            showTime
            allowClear={false}
            presets={[
              { label: '1 hour', value: DateTime.now().plus({ hours: 1 }) },
              { label: '1 day', value: DateTime.now().plus({ days: 1 }) },
              { label: '1 week', value: DateTime.now().plus({ days: 7 }) },
            ]}
            // if we send per sms we can't set a planned date
            disabled={transport === TRACKER_MESSAGE_TRANSPORT.SMS || forceNow}
          />
        </Form.Item>
        <Form.Item
          name="forceNow"
          className="form-input-force-now"
          colon={false}
          labelAlign="right"
          valuePropName="checked"
        >
          <Switch
            disabled={transport === TRACKER_MESSAGE_TRANSPORT.SMS}
            size="small"
            checkedChildren="Now"
            unCheckedChildren="Now"
          />
        </Form.Item>
      </VStack>
    </Container>
  );
};

const Container = styled(Form.Item)`
  width: 100%;

  .ant-form-item {
    margin-bottom: 0;
  }

  .form-input-force-now {
    margin-left: 150px;
  }

  .form-input-planned-at {
    width: 100%;
  }
`;
